import './abstract_section_view.coffee'
Namespace('Monitoring.Reports.Executive')

class Monitoring.Reports.Executive.CategoriesView extends Monitoring.Reports.Executive.AbstractSectionView
  id: 'categories'
  name: 'categories'
  tagName: 'section'
  template: JST["backbone/templates/monitoring/reports/executive/categories"]

  initialize: (@options = {}) ->
    @colors = {}
    @colors[@options.settings.accountLabel.codes[0]] = @options.settings.accountLabel.color
    $.each @options.settings.competitorsLabels, (index, label) =>
      @colors[label.codes[0]] = label.color

  render: ->
    @$el.html(@template(
      categories:@options.settings.categoryTags
      brands: (key for key of @colors)
    ))

    pending_charts = 0
    for category in @options.settings.categoryTags
      id = category.name.toLowerCase().replace(/\s/g, '-')
      pending_charts += 1
      @addCategoryHistogram(id, category)

    @bindChartsReady(pending_charts)
    return this

  addCategoryHistogram: (divId, category)->
    query = @extendedQuery({dimension: 'filtered_labels', tags: category.tag_list, labels: @labelFilter(), labels_structure: @labelsStructure()})
    @_addHistogram(query, "#bar-chart-#{divId}", { drillDownFunction: (clickEvent) =>
      from = new Date(clickEvent.point.x)
      to = new Date(clickEvent.point.x + clickEvent.point.series.pointInterval)
      tag_list = if category.nodes_names then [] else category.tag_list
      {
        date_from: @_formatDate(from)
        date_from_ISO: from.toISOString()
        date_to: @_formatDate(to)
        date_to_ISO: to.toISOString()
        labels: [clickEvent.point.series.name]
        tags: tag_list
        tags_node_name: category.nodes_names
      }
    } )
